const ARCSEC_PER_RAD = 206265;

export const effectiveFocalLengthMm = (telescopeFocalLengthMm, reducerFactor) =>
    telescopeFocalLengthMm * reducerFactor;

export const focalRatio = (effectiveFocalLengthMm, apertureMm) =>
    effectiveFocalLengthMm / apertureMm;

// Full-frame field of view along one sensor dimension, in degrees.
export const fovDegrees = (sensorDimensionMm, effectiveFocalLengthMm) =>
    2 * Math.atan(sensorDimensionMm / (2 * effectiveFocalLengthMm)) * (180 / Math.PI);

export const pixelScaleArcsecPerPixel = (pixelSizeUm, effectiveFocalLengthMm) =>
    (pixelSizeUm / (effectiveFocalLengthMm * 1000)) * ARCSEC_PER_RAD;

export const degreesToDegArcmin = (deg) => {
    const wholeDeg = Math.floor(deg);
    const arcmin = (deg - wholeDeg) * 60;
    if (wholeDeg === 0) return `${arcmin.toFixed(1)}'`;
    return `${wholeDeg}° ${arcmin.toFixed(1)}'`;
};
